
import { DataService } from "@/service/DataService";
import { isAdministrator } from "@/utils/functions";
import { LoginProvider, User } from "@/utils/models";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class ProviderView extends Vue {
  authLoginProviders: LoginProvider[] = [];
  dataService: DataService | null = null;
  targetProvider: LoginProvider | null = null;
  name = "";

  move(provider: LoginProvider, index: number, direction: -1 | 1) {
    const s = index;
    const d = index + direction;
    if (d < 0 || d >= this.authLoginProviders.length) {
      this.$toast.warning("不正な位置情報が選択されました。");
      return;
    }
    let a = [...this.authLoginProviders];
    [a[s], a[d]] = [a[d], a[s]];
    a.forEach((v, i) => (v.sortOrder = (i + 1) * 10));
    this.authLoginProviders = a;
    this.dataService!.emitUpdateSortOrder(a);
  }
  mounted() {
    this.dataService = this.$store.state.dataService;
    this.dataService!.emitGetLoginProviders().then((pv) => {
      this.authLoginProviders = pv;
      pv.sort((a, b) => a.sortOrder - b.sortOrder);
    });
  }

  startEdit(provider: LoginProvider) {
    this.name = provider.name;
    this.targetProvider = provider;
  }
  saveProviderName() {
    if (this.targetProvider && this.name !== this.targetProvider.name) {
      this.targetProvider.name = this.name;
      this.dataService!.emitUpdateLoginProviderName(
        this.targetProvider.id,
        this.name
      );
    }
    this.targetProvider = null;
  }
  toggleEnable(provider: LoginProvider) {
    this.dataService!.emitUpdateLoginProviderEnable(
      provider.id,
      !provider.enable
    );
    provider.enable = !provider.enable;
  }
  toggleAllowAccountCreationInAdvance(provider: LoginProvider) {
    this.dataService!.emitUpdateLoginProviderAllowAccountCreationInAdvance(
      provider.id,
      !provider.allowAccountCreationInAdvance
    );
    provider.allowAccountCreationInAdvance =
      !provider.allowAccountCreationInAdvance;
  }
  get user(): User {
    return this.$store.state.user;
  }
  get isAdministrator(): boolean {
    return isAdministrator(this.user);
  }
}
